import React, { useEffect, useState } from 'react'
import Loading from '../../Loading'
import { postConsultarFormasDeLiquidacion, postEliminarHonorariosFormasLiquidacion, postUpdateFormasDeLiquidacion } from '../../../services/Contratacion'
import ModalFactorFormasDeLiquidacion from './ModalFactorFormasDeLiquidacion'
import ModalConfirmarUpdateFormasDeLiquidacion from './ModalConfirmarUpdateFormasDeLiquidacion'
import ModalCuentasFormasDeLiquidacion from './ModalCuentasFormasDeLiquidacion'
import ModalRangosFormasDeLiquidacion from './ModalRangosFormasDeLiquidacion'

import ModalMensajeEliminarHonorarioFormasLiquidacion from './ModalMensajeEliminarHonorarioFormasLiquidacion'
import ModalAgregarUnaFormaDeLiquidacionEnUpdate from './ModalAgregarUnaFormaDeLiquidacionEnUpdate'

const ModalUpdateFormasDeLiquidar = ({setupdate,item,passDataActualizarDataFormasLiquidar}) => {
    const [consultarFormasLiquidacion, setconsultarFormasLiquidacion]=useState([])   
    const [loading,setloading]=useState(false)
    const [modalOnFactor, setmodalOnFactor]=useState(false)
    const [modalOnCuentas, setmodalOnCuentas]=useState(false)
    const [codigoFactor, setcodigoFactor]=useState('')
    const [modalOnConfirmarUpdateFormasLiquidar, setmodalOnConfirmarUpdateFormasLiquidar]=useState(false)
    const [agregarFormas, setagregarFormas]=useState(false)
    const [modalOnRangos, setmodalOnRangos]=useState(false)
    const [dataRango, setdataRango]=useState([])
    const [actulizarData, setactulizarData]=useState([])
    const [modalOnMensajeEliminarHonorario, setmodalOnMensajeEliminarHonorario]=useState(false)
    const [mensajeEliminarHonorario, setmensajeEliminarHonorario]=useState('')
    const [dataFormaLiquidarYHonorario, setdataFormaLiquidarYHonorario]=useState({
      ForLiqCod:'',
      HnrCod:'',
      HnrDsc:''
    })
    const [dataUpdateFormasLiquidacion, setdataUpdateFormasLiquidacion]=useState({
      ForLiqCod: '',
      ForLiqDsc: '',
      ForTiCru: '',
      datos: []
    })
    
    const handleCancelarClick=()=>{
        setupdate(false)
    }
    useEffect(()=>{
        const body={
            "forLiqCod":item.ForLiqCod            
        }
        setloading(false)
        postConsultarFormasDeLiquidacion(body).then((res)=>{
          setloading(true);              
          let data = res.data.data;
          let addInputHabilitado = data.map((itemLiqui)=>{
              // Aquí, se determina el valor de inputHabilitado
              const inputHabilitado = itemLiqui.ForLiqcar === 'F';
              // Aquí, se determina el valor de buttonRango
              const buttonRango = itemLiqui.ForLiqcar === 'R';
              
              // Se retorna el objeto modificado incluyendo ambos campos
              return {...itemLiqui, inputHabilitado, buttonRango};
          });
          setconsultarFormasLiquidacion(addInputHabilitado);        
      });
      
    },[actulizarData])

    // Manejar cambios en los selects de características
    const handleOnChangeCaracteristicas = (id, newValue) => {
        const updatedData = consultarFormasLiquidacion.map((item) => {
        if (item.HnrCod === id) {
          return { 
            ...item, 
            ForLiqcar: newValue, 
            inputHabilitado: 'F' === newValue,
            FctoCod: ('F' === newValue? item.FctoCod:''),
            FctoDsc: ('F' === newValue? item.FctoDsc:''),
            buttonRango: 'R' === newValue,
            ForLiqVlHn: ('R' === newValue? '':item.ForLiqVlHn)
          }
        }        
        return item;
        });        
        setconsultarFormasLiquidacion(updatedData);
    };

    const handleOnChangeLiquidacion = (id,ForInIm) => {        
        const updatedData = consultarFormasLiquidacion.map((itemLiqui) => {
            if (itemLiqui.HnrCod === id) {
              return { ...itemLiqui, ForInIm: ForInIm ? 'S' : 'N' };
            }
            return itemLiqui;
          });
          setconsultarFormasLiquidacion(updatedData)
    };

    const handleOnchangeBase = (id,FOREXCBAS) =>{
        const updatedData = consultarFormasLiquidacion.map((itemLiqui) => {
            if (itemLiqui.HnrCod === id) {
              return { ...itemLiqui, FOREXCBAS: FOREXCBAS ? 'S' : 'N' };
            }
            return itemLiqui;
          });
          setconsultarFormasLiquidacion(updatedData)

    }

    const handleOnchangeValorHonorarios = (id, newValue) => {
        const updatedData = consultarFormasLiquidacion.map((item) => {
          if (item.HnrCod === id) {
            return { ...item, ForLiqVlHn: newValue };
          }
          return item;
        });
    
        setconsultarFormasLiquidacion(updatedData);
      };

      const handleOnChangeCodigoQX=(id, newValue)=>{
        const updatedData = consultarFormasLiquidacion.map((item) => {
            if (item.HnrCod === id) {
              return { ...item, ForCodQx: newValue };
            }
            return item;
          });      
          setconsultarFormasLiquidacion(updatedData);
      }

      const handleOnSubmitGuardarModificacionFormasLiquidacion=(e)=>{     
        e.preventDefault();
        setdataUpdateFormasLiquidacion({
          ForLiqCod: e.target.codigo.value,
          ForLiqDsc: e.target.descripcion.value,
          ForTiCru: e.target.tipoCruento.value,
          datos: consultarFormasLiquidacion
        })
        setmodalOnConfirmarUpdateFormasLiquidar(true)
        
      }

      const handleOnfocusFactor=(codigo)=>{
        setmodalOnFactor(true)
        setcodigoFactor(codigo)
      }

      const passDataFactor=(codigo,descripcion)=>{
        setmodalOnFactor(false)
        const modificarFactor= consultarFormasLiquidacion.map((item)=>{
          if(item.HnrCod === codigoFactor){
            return {
              ...item,
              FctoCod: codigo,
              FctoDsc: descripcion,           
             }
          }
          return item;
        })
        setconsultarFormasLiquidacion(modificarFactor)
      }

      const handleOnclicCuentas=(honorario,descripcion)=>{        
        setdataFormaLiquidarYHonorario({
          ForLiqCod: item.ForLiqCod,
          HnrCod: honorario,
          HnrDsc: descripcion
        })
        setmodalOnCuentas(true)
      }

      const handleOnclicRangos=(data)=>{
        setmodalOnRangos(true)
        setdataRango(data)
      }

      const handleOnClickAgregar=()=>{
        setagregarFormas(true)
    }

    const handleOnclickEliminarHonorario=(forma, honorario)=>{
      const eliminar={
        ForLiqCod: forma,
        HnrCod: honorario
      }
      postEliminarHonorariosFormasLiquidacion(eliminar).then((res)=>{
        if(!res.data.success){          
          setmensajeEliminarHonorario(res.data.message)
          setmodalOnMensajeEliminarHonorario(true)
        }else{
          setactulizarData(eliminar)
        }
      })
    }
     
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-full  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Modificar formas Liquidación
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form onSubmit={handleOnSubmitGuardarModificacionFormasLiquidacion}>
              <div className="flex py- text-left">
                <div className="w-1/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Código
                  </label>
                  <div className="flex">
                    <input
                      
                      defaultValue={item.ForLiqCod}
                      disabled={true}
                      type="text"
                      name="codigo"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción
                  </label>
                  <div className="flex">
                    <input
                      
                      defaultValue={item.ForLiqDsc}
                      name="descripcion"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    {/* <label className="px-2">Tipo cruento</label>
                    <input
                      
                      name="nombre"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    /> */}
                    
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo cruento
                  </label>
                  <div className="flex">
                  <select          
                    //onChange={handleOnchangeCaracteristica} 
                    defaultValue={item.ForTiCru}         
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='tipoCruento'
                  >
                    <option value="N">Cruento</option>
                    <option value="S">No cruento</option>                    
                  </select>
                    {/* <button
                      type="submit"
                      className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button> */}
                  </div>
                </div>
              </div>
              <div className="flex  text-left p-2">
              <button
                  onClick={handleOnClickAgregar}
                  type="button"
                  className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Agregar Formas De Liquidar
                </button>
                </div>
                
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full sm:px-3 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                          <th></th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Nuevo Plan de Cuentas
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Eliminar
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Código
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Descripción
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Característica
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Vlr Honorarios
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Factor
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Descripción Del Factor
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                           Liqui?
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Codigo Qx
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            No. Apli. %Base
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          consultarFormasLiquidacion.map((item, index) => (
                            <tr className=" divide-y divide-slate-700 " key={index}>
                              <td></td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                <button
                                  type="button"
                                  onClick={()=>handleOnclicCuentas(item.HnrCod,item.HnrDsc)}
                                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                                >
                                  Cuentas
                                </button>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                <button
                                  type="button"
                                  onClick={()=>handleOnclickEliminarHonorario(item.ForLiqCod,item.HnrCod)}
                                  className="inline-block px-4 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out "
                                >
                                  Eliminar
                                </button>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.HnrCod}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                                {item.HnrDsc? item.HnrDsc.trim():null}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                                
                              <div className="flex justify-center items-center">
                                    <select 
                                    onChange={(e) => handleOnChangeCaracteristicas(item.HnrCod, e.target.value)}
                                    value={item.ForLiqcar}
                                    className="form-select w-32 h-7 px-2 py-1.5 text-xs font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                    aria-label="Default select example">
                                    <option value="U">UVR</option>
                                    <option value="R">RANGO</option>
                                    <option value="V">VALOR FIJO</option>
                                    <option value="T">TIEMPO</option>
                                    <option value="A">VALOR VARIABLE</option>
                                    <option value="F">FACTOR</option>
                                    </select>
                                </div>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                              {
                                item.buttonRango?
                                <button type="button"
                                  onClick={()=>handleOnclicRangos(item)}
                                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                                  Rango
                                </button>
                                :
                                <div className="flex justify-center">
                                    <input 
                                    onChange={(e) => handleOnchangeValorHonorarios(item.HnrCod, e.target.value)}
                                    value={item.ForLiqVlHn}
                                    type="number"
                                    className="w-32 h-6 form-select  max-w-xs px-2 py-1.5 text-xs font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                    aria-label="Default select example"
                                    />
                                </div>
                              }                               
                                
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                { item.inputHabilitado?
                                <div className="flex justify-center">
                                <input 
                                
                                value={item.FctoCod}
                                onFocus={(e)=>handleOnfocusFactor(item.HnrCod)}
                                type="number"
                                className="w-32 h-6 form-select  max-w-xs px-2 py-1.5 text-xs font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                aria-label="Default select example"
                                readOnly
                                />
                            </div>
                                : item.FctoCod
                                }
                                
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.FctoDsc? item.FctoDsc.trim():null}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                                
                                <div className="topping">
                                    <input
                                    type="checkbox"                                    
                                    checked={item.ForInIm === 'S'}
                                    onChange={(e)=>handleOnChangeLiquidacion(item.HnrCod, e.target.checked)}
                                    />
                                </div>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                                
                                <div className="flex justify-center">                                    
                                        <input 
                                        onChange={(e)=>handleOnChangeCodigoQX(item.HnrCod, e.target.value)}                                          
                                        value={item.ForCodQx}
                                        type="text"
                                        className="w-24 h-6 form-select  max-w-xs px-2 py-1.5 text-xs font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 

                                        aria-label="Default select example"/>                                    
                                </div>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                
                                <div className="topping">
                                    <input
                                    type="checkbox"                                    
                                    checked={item.FOREXCBAS === 'S'}
                                    onChange={(e)=>handleOnchangeBase(item.HnrCod, e.target.checked)}
                                    />
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                              <Loading /> 
                            </td>
                          </tr>
                        )}
                        
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Guardar
          </button>
          </div>
          </form>
          </div>
        </div>
      </div>
      {modalOnFactor? <ModalFactorFormasDeLiquidacion setmodalOnFactor={setmodalOnFactor} passDataFactor={passDataFactor}/>:null}
      {modalOnConfirmarUpdateFormasLiquidar? <ModalConfirmarUpdateFormasDeLiquidacion setmodalOnConfirmarUpdateFormasLiquidar={setmodalOnConfirmarUpdateFormasLiquidar} dataUpdateFormasLiquidacion={dataUpdateFormasLiquidacion} setupdate={setupdate} passDataActualizarDataFormasLiquidar={passDataActualizarDataFormasLiquidar}/>:null}
      {modalOnCuentas? <ModalCuentasFormasDeLiquidacion setmodalOnCuentas={setmodalOnCuentas} dataFormaLiquidarYHonorario={dataFormaLiquidarYHonorario}/>:null}
      {modalOnRangos? <ModalRangosFormasDeLiquidacion setmodalOnRangos={setmodalOnRangos} dataRango={dataRango}/>:null}      
      {agregarFormas? <ModalAgregarUnaFormaDeLiquidacionEnUpdate setagregarFormas={setagregarFormas} setactulizarData={setactulizarData} item={item.ForLiqCod}/>:null}
      {modalOnMensajeEliminarHonorario? <ModalMensajeEliminarHonorarioFormasLiquidacion setmodalOnMensajeEliminarHonorario={setmodalOnMensajeEliminarHonorario} mensajeEliminarHonorario={mensajeEliminarHonorario}/>:null}
    </div>
  )
}

export default ModalUpdateFormasDeLiquidar